import { MasterButton } from "App/Component/ui";

export const StatusOrganisasi = ({ status }) => {
	if (status === true) {
		return <MasterButton type="button" name="Aktif" color="lightgreen" />;
	} else {
		return <MasterButton type="button" name="Tidak Aktif" color="secondary" />;
	}
};

export const StatusLokasi = ({ status }) => {
	if (status === "active") {
		return <MasterButton type="button" name="Aktif" color="lightgreen" />;
	} else if (status === "suspended") {
		return <MasterButton type="button" name="Diblokir" color="danger" />;
	} else if (status === "inactive") {
		return <MasterButton type="button" name="Tidak Aktif" color="secondary" />;
	}
};